export default __webpack_public_path__ + "static/mouth-c97eeb085e739baf9f353fa8aefcad52.webp";